<script setup>
import {v4 as uuidv4} from "uuid"
import {computed} from "vue"
import {useI18n} from "vue-i18n"

const props = defineProps({
  modelValue: {
    type: [Number, String, Boolean],
    default: ''
  },
  validator: {
    type: Object,
    default: () => {
    }
  },
  label: {
    type: String,
    default: ''
  },
  error: {
    type: String,
    default: ''
  }
})

const inputValue = computed({
  get() {
    return props.modelValue
  },
  set(newValue) {
    emits("update:modelValue", newValue)
  }
})

const { t } = useI18n()

const errorMessage = computed(() => {
  if (props.validator?.$errors.length) {
    return props.validator.$errors.map(
        error => t(error.$message)
    ).join(',')
  }

  return props.error ? t(props.error) : ''
})

const emits = defineEmits(['update:modelValue'])

const id = computed(() => `input-${uuidv4()}`)

</script>

<template>
  <div class="input-group checkbox-group">
    <div
      :class="{
          'error': !! errorMessage,
        }"
      class="checkbox checkbox--medium"
    >
      <input
        :id="id"
        v-model="inputValue"
        v-bind="$attrs"
        type="checkbox"
        class="checkbox__input"
      />
      <span class="checkbox__indicator"></span>
    </div>

    <div class="input-group__label-wrapper">
      <label v-if="label" class="checkbox__label" :for="id" v-html="label" />
      <label v-else class="checkbox__label" :for="id">
        <slot />
      </label>

      <label class="input-error" v-if="errorMessage">
        {{ errorMessage}}
      </label>
    </div>
  </div>
</template>